import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import { setCookie } from '../../utils/cookie';
import CryptoJS from 'crypto-js';


const initialState = {
  status: null,
  message: null,
  customerId: null,
  appLimit: null
}

let logoutResponse = {
  "status": "SUCCESS_LOGOUT",
}

export const loginUser = createAsyncThunk("loginUser", async (credentials) => {
  try {
    const response = await fetch(`/api/userLogin`, {
      method: 'POST',
      headers: {
        Accept: "application/json",
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(credentials)
    })
    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(errorData.errorMessage);
    }
    return await response.json();
  } catch (error) {
    throw new Error(error);
  }
});

export const logoutUser = createAsyncThunk("logoutUser", async () => {
  return logoutResponse;
});


const loginSlice = createSlice({
  name: "loginUser",
  initialState,
  extraReducers: (builder) => {
    builder.addCase(loginUser.pending, (state) => {
      state.status = "loading"
    });
    builder.addCase(loginUser.fulfilled, (state, action) => {
      state.status = action.payload.data.status
      state.customerId = action.payload.data.data.struCustomerId
      if (action.payload.data.data.struCustomerId) {
        const customerId = CryptoJS.AES.encrypt(JSON.stringify(action.payload.data.data.struCustomerId), 'fc4db694c037f966e0bb694329460460').toString();
        setCookie("custId", customerId)
      }
      state.appLimit = action.payload.data.data.appLimit

    });
    builder.addCase(loginUser.rejected, (state, action) => {
      let errorMsg = action.error.message.replace("Error: ", "")
      state.status = "error"
      state.message = errorMsg
    });
    builder.addCase(logoutUser.pending, (state) => {
      state.status = "loading"
    });
    builder.addCase(logoutUser.fulfilled, (state, action) => {
      state.status = action.payload.status

    });
    builder.addCase(logoutUser.rejected, (state) => {
      state.status = "error"
      state.message = "Please try again"
    });
  }
})

export default loginSlice.reducer